"use client";
import { createContext, useContext, useEffect, useState } from "react";

type CookieContextType = {
  cookiesAccepted: boolean;
  setCookiesAccepted: (value: boolean) => void;
};

const CookieContext = createContext<CookieContextType>({
  cookiesAccepted: false,
  setCookiesAccepted: () => {},
});

export function CookieProvider({ children }: { children: React.ReactNode }) {
  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted") === "true";
    setCookiesAccepted(accepted);
  }, []);

  return (
    <CookieContext.Provider value={{ cookiesAccepted, setCookiesAccepted }}>
      {children}
    </CookieContext.Provider>
  );
}

export function useCookieConsent() {
  return useContext(CookieContext);
}
